/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { SlotService } from "../slot/slot.service";

@Injectable({
  providedIn: "root",
})
export class ReportsService {
  amazonHeaders = [
    { name: "Vendor Code" },
    { name: "Vendor SKU" },
    { name: "Product Type" },
    { name: "Item Name" },
    { name: "Brand Name" },
    { name: "External Product ID Type" },
    { name: "External Product ID" },
    { name: "Merchant Suggested Asin" },
    { name: "Product Category" },
    { name: "Product Subcategory" },
    { name: "Item Type Keyword" },
    { name: "Item Type Name" },
    { name: "Model Name" },
    { name: "Color" },
    { name: "Color Map" },
    { name: "Model Number" },
    { name: "List Price" },
    { name: "Cost Price" },
    { name: "Bullet Point", sequence: 1 },
    { name: "Bullet Point", sequence: 2 },
    { name: "Bullet Point", sequence: 3 },
    { name: "Bullet Point", sequence: 4 },
    { name: "Bullet Point", sequence: 5 },
    { name: "Generic Keyword" },
    { name: "Generic Keyword" },
    { name: "Generic Keyword" },
    { name: "Generic Keyword" },
    { name: "Generic Keyword" },
    { name: "Special Features" },
    { name: "Special Features" },
    { name: "Special Features" },
    { name: "Special Features" },
    { name: "Special Features" },
    { name: "Lifestyle" },
    { name: "Style" },
    { name: "Department Name" },
    { name: "Target Gender" },
    { name: "Age Range Description" },
    { name: "Fabric Type" },
    { name: "Fur Description" },
    { name: "Water Resistance Level" },
    { name: "Subject Character" },
    { name: "Special Size" },
    { name: "Product Description" },
    { name: "Footwear Size System", sequence: 1 },
    { name: "Footwear Age Group", sequence: 1 },
    { name: "Footwear Gender", sequence: 1 },
    { name: "Footwear Size Class", sequence: 1 },
    { name: "Footwear Width", sequence: 1 },
    { name: "Footwear Size", sequence: 1 },
    { name: "Footwear To Size", sequence: 1 },
    { name: "Footwear Size System", sequence: 2 },
    { name: "Footwear Age Group", sequence: 2 },
    { name: "Footwear Gender", sequence: 2 },
    { name: "Footwear Size Class", sequence: 2 },
    { name: "Footwear Width", sequence: 2 },
    { name: "Footwear Size", sequence: 2 },
    { name: "Footwear To Size", sequence: 2 },
    { name: "Item Booking Date" },
    { name: "Sub Brand" },
    { name: "Sole Material" },
    { name: "Toe Style" },
    { name: "Closure Type" },
    { name: "Built-in Light" },
    { name: "Arch Type" },
    { name: "Height Map" },
    { name: "Heel Height" },
    { name: "Heel Height Unit" },
    { name: "Heel Type" },
    { name: "Product Lifecycle Supply Type" },
    { name: "Seasons" },
    { name: "Duration" },
    { name: "Duration Unit" },
    { name: "Country of Origin" },
    { name: "Are batteries required?" },
    { name: "Are batteries included?" },
    { name: "Battery Cell Composition" },
    { name: "Battery Weight" },
    { name: "Battery Weight Unit" },
    { name: "Number of Batteries" },
    { name: "Battery Type" },
    { name: "Number of Batteries" },
    { name: "Battery Type" },
    { name: "Number of Batteries" },
    { name: "Battery Type" },
    { name: "Number of Batteries" },
    { name: "Battery Type" },
    { name: "Number of Batteries" },
    { name: "Battery Type" },
    { name: "Number of Lithium Metal Cells" },
    { name: "Number of Lithium-ion Cells" },
    { name: "Lithium Battery Energy Content" },
    { name: "Lithium Battery Energy Content Unit" },
    { name: "Lithium Battery Packaging" },
    { name: "Lithium Content" },
    { name: "Lithium Content Unit" },
    { name: "Dangerous Goods Regulations", sequence: 1 },
    { name: "Dangerous Goods Regulations" },
    { name: "Dangerous Goods Regulations" },
    { name: "Dangerous Goods Regulations" },
    { name: "Dangerous Goods Regulations" },
    { name: "Hazmat Aspect" },
    { name: "Hazmat" },
    { name: "Safety Data Sheet (SDS or MSDS) URL" },
    { name: "GHS Class" },
    { name: "Import Designation" },
    { name: "Material/Fabric Regulations", sequence: 1 },
    { name: "Material/Fabric Regulations", sequence: 2 },
    { name: "Material/Fabric Regulations", sequence: 3 },
    { name: "California Proposition 65 Warning Type" },
    { name: "California Proposition 65 Chemical Name(s)" },
    { name: "California Proposition 65 Chemical Name(s)" },
    { name: "California Proposition 65 Chemical Name(s)" },
    { name: "California Proposition 65 Chemical Name(s)" },
    { name: "California Proposition 65 Chemical Name(s)" },
    { name: "Mandatory Cautionary Statement", sequence: 1 },
    { name: "Mandatory Cautionary Statement", sequence: 2 },
    { name: "Mandatory Cautionary Statement", sequence: 3 },
    { name: "Mandatory Cautionary Statement", sequence: 4 },
    { name: "Mandatory Cautionary Statement", sequence: 5 },
    { name: "Earliest Shipping Date" },
    { name: "Item Package Length" },
    { name: "Package Length Unit" },
    { name: "Item Package Width" },
    { name: "Package Width Unit" },
    { name: "Item Package Height" },
    { name: "Package Height Unit" },
    { name: "Package Weight" },
    { name: "Package Weight Unit" },
    { name: "Order Aggregate Type" },
    { name: "Items per Inner Pack" },
    { name: "Inner Packs Per Master Pack" },
  ];
  constructor(public slotService: SlotService) {}
  getGradeValue(definition, attribute) {
    const index = definition.findIndex(
      (eachDefinition) => eachDefinition.attributeKey === attribute
    );
    return index === -1 ? "" : definition[index].attributeValue;
  }

  getAmazonData(product, header, sequence) {
    switch (header) {
      case "Vendor SKU":
        return product.SKU;
      case "Product Type":
        const names = product.productMainCategoryName.split("(");
        return names && names.length > 1
          ? names[0]
          : product.productMainCategoryName;
      case "Item Name":
        return product.productName;
      case "Brand Name":
        return product.brandName;
      case "External Product ID Type":
        return "UPC";
      case "External Product ID":
        return product.upcCode;
      case "Merchant Suggested Asin":
        return product.localCode;
      case "Product Category":
        return this.getGradeValue(
          product.gradeDefinition,
          "Product Lifecycle Supply Type"
        );
      case "Product Subcategory":
        return product.brandVarietyName;
      case "Item Type Keyword":
        return this.getGradeValue(product.gradeDefinition, "Item Type Keyword");
      case "Item Type Name":
        return this.getGradeValue(product.gradeDefinition, "Item Type Name");
      case "Color":
        return this.getGradeValue(product.gradeDefinition, "Colour");
      case "Color Map":
        return this.getGradeValue(product.gradeDefinition, "Color Map");
      case "Model Number":
        return this.getGradeValue(product.gradeDefinition, "Style Code");
      case "List Price":
        return product.price.MRP && product.price.MRP.value
          ? this.slotService.getFormattedCurrency(product.price.MRP.value)
          : "";
      case "Cost Price":
        return product.price.dealerPrice && product.price.dealerPrice.value
          ? this.slotService.getFormattedCurrency(
              product.price.dealerPrice.value
            )
          : "";
      case "Bullet Point":
        return sequence && sequence === 1
          ? this.getGradeValue(product.gradeDefinition, "Bullet Point")
          : "";
      case "Style":
        return product.productName;
      case "Department Name":
        return this.getGradeValue(product.gradeDefinition, "Footwear Gender");
      case "Target Gender":
        return this.getGradeValue(product.gradeDefinition, "Target Gender");
      case "Age Range Description":
        return this.getGradeValue(
          product.gradeDefinition,
          "Age Range Description"
        );
      case "Water Resistance Level":
        return this.getGradeValue(
          product.gradeDefinition,
          "Water Resistance Level"
        );
      case "Product Description":
        return this.getGradeValue(product.gradeDefinition, "Style Description");
      case "Footwear Size System":
        return sequence && sequence === 1
          ? this.getGradeValue(product.gradeDefinition, "Footwear Size System")
          : "";
      case "Footwear Age Group":
        return sequence && sequence === 1
          ? this.getGradeValue(product.gradeDefinition, "Footwear Age Group")
          : "";
      case "Footwear Gender":
        return sequence && sequence === 1
          ? this.getGradeValue(product.gradeDefinition, "Footwear Gender")
          : "";
      case "Footwear Width":
        return sequence && sequence === 1
          ? this.getGradeValue(product.gradeDefinition, "Footwear Width")
          : "";
      case "Footwear Size":
        return sequence && sequence === 1
          ? this.getGradeValue(product.gradeDefinition, "Size")
          : "";
      case "Footwear Size Class":
        return sequence && sequence === 1
          ? this.getGradeValue(product.gradeDefinition, "Footwear Size Class")
          : "";
      case "Sole Material":
        return this.getGradeValue(product.gradeDefinition, "Sole Material");
      case "Closure Type":
        return this.getGradeValue(product.gradeDefinition, "Closure Type");
      case "Height Map":
        return this.getGradeValue(product.gradeDefinition, "Height Map");
      case "Product Lifecycle Supply Type":
        return this.getGradeValue(
          product.gradeDefinition,
          "Product Lifecycle Supply Type"
        );
      case "Seasons":
        return this.getGradeValue(product.gradeDefinition, "Seasons");
      case "Duration":
        return this.getGradeValue(product.gradeDefinition, "Duration");
      case "Duration Unit":
        return this.getGradeValue(product.gradeDefinition, "Duration Unit");
      default:
        return this.getGradeValue(product.gradeDefinition, header);
    }
  }
  downloadFile(data, name, format?) {
    const reportMimeType =
      format === ".csv"
        ? "application/csv"
        : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    console.log(data);
    const file = new Blob([data], { type: reportMimeType });
    const fileURL = URL.createObjectURL(file);
    // window.open(fileURL);
    const anchor = document.createElement("a");
    anchor.download = name + (format ?? ".xlsx");
    anchor.href = fileURL;
    anchor.click();
  }
}
